<template>
  <tr v-if="prices">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
      <v-row align="center" no-gutters>
        <v-icon x-small class="mx-1 mr-2">mdi-help-circle-outline</v-icon> Min/Max Stay Through
      </v-row>
    </th>
    <td class="sheet-cell" v-for="(price, index) in prices" :key="index">

      <v-progress-circular v-if="price.msiu" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.min_stay_through" class="sheet-input-left" @change="updateMinStayThrough(price)"/>

      <v-progress-circular v-if="price.msau" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.max_stay_through" class="sheet-input-right" @change="updateMaxStayThrough(price)"/>

    </td>
  </tr>
</template>


<script>
  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      prices: null
    },

    methods: {

      async updateMinStayThrough(data) {
        try {
          this.$set(data, 'msiu', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'msiu', false);
        }
      },

      async updateMaxStayThrough(data) {
        try {
          this.$set(data, 'msau', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'msau', false);
        }
      }

    }
  }
</script>


<style scoped>
  @import '../sheet.css';
</style>